import { refreshPage } from "../index";

export function newsFilter() {
  if (document.querySelector(".m-news-events.type-filter-all")) {
    const checkboxes = document.querySelectorAll(".news-category-filter");
    const newsItems = document.querySelectorAll(".filter-results--news > li");
    const filterResultsContainer = document.querySelector(
      ".filter-results-container",
    );
    const filterResultsNews = document.querySelector(".filter-results--news");

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener("change", function () {
        const selectedCategories = Array.from(checkboxes)
          .filter((cb) => cb.checked)
          .map((cb) => cb.value);

        newsItems.forEach(function (item) {
          const itemCategories = item.dataset.categories.split(" ");
          const shouldDisplay = itemCategories.some((cat) =>
            selectedCategories.includes(cat),
          );
          item.style.display = shouldDisplay ? "block" : "none";
        });

        filterResultsContainer.style.height =
          filterResultsNews.offsetHeight + "px";

        refreshPage();
      });
    });

    const eventsButton = document.querySelector(".events-button");
    if (eventsButton) {
      eventsButton.addEventListener("click", function () {
        setTimeout(function () {
          const checkboxes = document.querySelectorAll(
            ".news-filter-sidebar input",
          );
          checkboxes.forEach(function (checkbox) {
            checkbox.checked = true;
          });
          newsItems.forEach(function (item) {
            item.style.display = "block";
          });
        }, 300);
      });
    }
  }
}
